import { render } from "./7_vivienda.vue?vue&type=template&id=08418a79&scoped=true"
import script from "./7_vivienda.vue?vue&type=script&lang=js"
export * from "./7_vivienda.vue?vue&type=script&lang=js"

import "./7_vivienda.vue?vue&type=style&index=0&id=08418a79&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08418a79"]])

export default __exports__